import axios from "axios";
import { settings } from "@config/settings/app.settings";
import { store } from "@config/store/app.store";

export const logIt = async (data) => {
    try {
        const { centralized, logUrl, accessToken, client, platform } =
            settings.logging;
        const {
            page = "Unknown",
            problem = "Unknown",
            criticality = 9,
            trace = "",
        } = data;

        if (centralized) {
            const state = store.getState();
            const user = state.auth.user;
            const strTrace = JSON.stringify(trace);
            await axios({
                method: "post",
                url: `${logUrl}api/v1/logs/log`,
                data: {
                    client: client,
                    platform: platform,
                    page: page,
                    user_id: user?._id,
                    username: user?.username,
                    problem: problem,
                    criticality: criticality,
                    trace:
                        isJson(strTrace) && typeof trace !== "string"
                            ? strTrace
                            : trace,
                },
                headers: {
                    "Content-Type": "application/json",
                    "access-token": accessToken,
                },
            });
        }
    } catch (error) {
        console.log("Unable to log:", error);
    }
};

function isJson(value) {
    if (typeof value !== "string") {
        return false;
    }
    try {
        JSON.parse(value);
        return true;
    } catch (e) {
        return false;
    }
}
